import React from 'react';
import { DraggableProvided } from '@hello-pangea/dnd';
import { AiManagementBoardTask } from 'store/modules/ai_management_store/types';
import { taskStateOf } from 'services/ai_management_task_state';
import { initialsOf } from 'services/initials';
import { formatDate } from 'services/ai_management_dates';
import AiManagementAvatar from 'components/atoms/ai_management_avatar';
import { Container } from './styles';

interface AiManagementTaskBoardCardProps {
  task: AiManagementBoardTask;
  provided: DraggableProvided;
  isDragging: boolean;
  onOpen: (task: AiManagementBoardTask) => void;
}

const AiManagementTaskBoardCard: React.FC<AiManagementTaskBoardCardProps> = ({
  task,
  provided,
  isDragging,
  onOpen,
}) => {
  const { label, badge } = taskStateOf(task);
  const { bidding } = task;

  return (
    <Container
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className={`card mb-2 ${isDragging ? 'shadow' : ''}`}
      role="button"
      tabIndex={0}
      aria-label={`Abrir ${task.title}`}
      onClick={() => onOpen(task)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onOpen(task);
        }
      }}
    >
      <div className="card-body p-2">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <span className="badge badge-dark">{bidding.notice_number}</span>
          <span className="btn btn-secondary btn-sm d-flex align-items-center" aria-hidden="true">
            <i className="material-icons">chevron_right</i>
          </span>
        </div>

        <div className="font-weight-bold text-dark mb-1">{task.title}</div>

        <div className="d-flex align-items-center flex-wrap mb-1">
          {task.deadline && (
            <span className="d-flex align-items-center mr-2">
              <i className="material-icons mr-1">event</i>
              {formatDate(task.deadline)}
            </span>
          )}
          <span className={`badge badge-${badge}`}>{label}</span>
        </div>

        <div className="card-location">{bidding.public_body}</div>
        <div className="card-location mb-2">
          {bidding.city} - {bidding.state}
        </div>

        <div className="d-flex align-items-center">
          {!!task.counts.comments && (
            <span className="task-card-count border rounded d-flex align-items-center mr-2">
              <i className="material-icons mr-1">chat_bubble_outline</i>
              {task.counts.comments}
            </span>
          )}
          {!!task.counts.attachments && (
            <span className="task-card-count border rounded d-flex align-items-center">
              <i className="material-icons mr-1">attach_file</i>
              {task.counts.attachments}
            </span>
          )}
          {task.responsible && (
            <span className="ml-auto">
              <AiManagementAvatar
                initials={initialsOf(task.responsible.name)}
                memberId={task.responsible.id}
                name={task.responsible.name}
                size={32}
                bordered
                balloonPosition="up-right"
              />
            </span>
          )}
        </div>
      </div>
    </Container>
  );
};

export default AiManagementTaskBoardCard;
